import { LOG_LEVEL } from '@klarna/frontend-events';
import createTracker from './createTracker';
const instances = {};
export default function trackerFactory(id) {
    let logLevel = LOG_LEVEL.INFO;
    let extraData = {};
    const event = (name, postData = {}, options = {}, level = LOG_LEVEL.INFO) => {
        if (level < logLevel) {
            return;
        }
        if (instances[id]) {
            instances[id].event(name, {
                level,
                ...options,
                ...extraData,
                ...postData,
            }, {}, level);
        }
    };
    const eventsFactory = (event, logLevel) => (name, postData = {}, options = {}) => event(name, postData, options, logLevel);
    return {
        configure: ({ options, data = {}, instanceId = undefined }) => {
            extraData = data;
            if (!instances[id]) {
                instances[id] = createTracker(configWithInstanceId({
                    ...options,
                    instanceId,
                }));
            }
        },
        event,
        trace: eventsFactory(event, LOG_LEVEL.TRACE),
        debug: eventsFactory(event, LOG_LEVEL.DEBUG),
        info: eventsFactory(event, LOG_LEVEL.INFO),
        warn: eventsFactory(event, LOG_LEVEL.WARN),
        error: eventsFactory(event, LOG_LEVEL.ERROR),
        fatal: eventsFactory(event, LOG_LEVEL.FATAL),
        setLogLevel(logLevelKey = 'ALL') {
            try {
                const logLevelKeyUpperCase = logLevelKey.toUpperCase();
                logLevel =
                    logLevelKeyUpperCase in LOG_LEVEL
                        ? LOG_LEVEL[logLevelKeyUpperCase]
                        : LOG_LEVEL.ALL;
                if (instances[id]) {
                    instances[id].setLogLevel(logLevel);
                }
            }
            catch (error) {
                // at least we try
            }
        },
        removeInstance() {
            if (instances[id]) {
                delete instances[id];
            }
        },
    };
}
const configWithInstanceId = ({ client = 'sdk', clientVersion = '', sessionId = '', instanceId, baseUrl = '', }) => ({
    client,
    clientVersion,
    environment: process.env.NODE_ENV,
    sessionId,
    instanceId,
    baseUrl,
});
